export const API_LIST_THIRD_PARTY = 'API_LIST_THIRD_PARTY';
export const API_RELOAD_THIRD_PARTY = 'API_RELOAD_THIRD_PARTY';
export const API_REVOKE_TOKEN = 'API_REVOKE_TOKEN';
export const API_RESET_API_KEY = 'API_RESET_API_KEY';
